import React from "react";
import { Link } from "react-router-dom";
import { footerLinks } from "../data/redlandGolfContent";
import { useSiteContent } from "../context/ContentContext";

export function SiteFooter() {
  const { contact } = useSiteContent();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-grid">
        <div>
          <p className="footer-title">{contact.clubName}</p>
          <address>
            <a href={contact.directionsHref}>
              {contact.addressLine1}
              <br />
              {contact.cityStateZip}
            </a>
          </address>
          <p>
            <a href={contact.phoneHref}>{contact.phoneDisplay}</a>
          </p>
          <p>
            <a href={contact.emailHref}>{contact.email}</a>
          </p>
        </div>

        <nav aria-label="Footer quick links" className="footer-links">
          <p className="footer-heading">Quick Links</p>
          {footerLinks.map((link) => (
            <Link to={link.href} key={link.href} data-testid={`footer-link-${link.href}`}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="footer-note">
          <p className="footer-heading">Tee Times</p>
          <p>Call the Pro Shop for tee times.</p>
          <a className="footer-phone" href={contact.phoneHref}>
            305-247-8503, extension 1
          </a>
        </div>
      </div>
    </footer>
  );
}
